export default "__VITE_ASSET__RCoFbR20__"